import {
  Device,
  DeviceGroup,
  Room,
  DeviceAction,
  ScriptsData,
  ScriptsDataSingle,
  SafetySettings,
  SafetyList,
  SettingsSmartHome,
  AllowRemoteControl,
  PairingDeviceList,
  PairingDevice,
  DeviceStatistic,
  StatusResultCode,
  StatusData,
  Parameter,
  AlarmType,
  Weekday,
  DeviceType,
  ParameterType,
  ConditionType
} from './types';
import { 
  mockDevices as importedMockDevices,
  mockRooms,
  mockDeviceStatistics
} from './mockData';

const mockDevices: Device[] = [...importedMockDevices];

const mockScripts: DeviceAction[] = [
  {
    id: 'script_001',
    actionId: 'script_001',
    name: 'Утренний свет',
    type: 'device_trigger' as any,
    isActive: true,
    conditionType: ConditionType.AndCondition,
    flatId: 1,
    groupDeviceId: 'group_001',
    groupName: 'Автоматизация',
    ifDevices: [
      {
        id: 'if_001',
        deviceId: 'device_009',
        deviceName: 'Движение в коридоре',
        deviceType: DeviceType.MotionSensor,
        room: 'Коридор',
        params: {
          comparison: null,
          parameterName: 'motion',
          parameterNameRus: 'Движение',
          rusValueOnlyView: null,
          description: null,
          paramType: ParameterType.Bool,
          typeAction: 'device_condition' as any,
          time: null,
          stringValue: 'true',
          boolValue: true,
          numericValue: null,
          daysOfWeek: null
        }
      }
    ],
    thenDevices: [
      {
        id: 'then_001',
        deviceId: 'device_001',
        deviceName: 'Лампа в гостиной',
        deviceType: DeviceType.Relay,
        room: 'Гостиная',
        params: {
          comparison: null,
          parameterName: 'power',
          parameterNameRus: 'Питание',
          rusValueOnlyView: null,
          description: null,
          paramType: ParameterType.Bool,
          typeAction: 'zigbee_action' as any,
          time: null,
          stringValue: 'true',
          boolValue: true,
          numericValue: null,
          daysOfWeek: null
        }
      }
    ]
  },
  {
    id: 'script_002',
    actionId: 'script_002',
    name: 'Ночной режим',
    type: 'device_trigger' as any,
    isActive: true,
    conditionType: ConditionType.AndCondition,
    flatId: 1,
    groupDeviceId: 'group_001',
    groupName: 'Автоматизация',
    ifDevices: [
      {
        id: 'if_002',
        deviceId: 'device_008',
        deviceName: 'Входная дверь',
        deviceType: DeviceType.DoorSensor,
        room: 'Коридор',
        params: {
          comparison: null,
          parameterName: 'state',
          parameterNameRus: 'Состояние',
          rusValueOnlyView: null,
          description: null,
          paramType: ParameterType.Bool,
          typeAction: 'device_condition' as any,
          time: null,
          stringValue: 'true',
          boolValue: true,
          numericValue: null,
          daysOfWeek: null
        }
      }
    ],
    thenDevices: [
      {
        id: 'then_002',
        deviceId: 'device_015',
        deviceName: 'Розетка у кровати',
        deviceType: DeviceType.Socket,
        room: 'Спальня',
        params: {
          comparison: null,
          parameterName: 'power',
          parameterNameRus: 'Питание',
          rusValueOnlyView: null,
          description: null,
          paramType: ParameterType.Bool,
          typeAction: 'zigbee_action' as any,
          time: null,
          stringValue: 'false',
          boolValue: false,
          numericValue: null,
          daysOfWeek: null
        }
      }
    ]
  },
  {
    id: 'script_003',
    actionId: 'script_003',
    name: 'Климат контроль',
    type: 'device_trigger' as any,
    isActive: false,
    conditionType: ConditionType.AndCondition,
    flatId: 1,
    groupDeviceId: 'group_001',
    groupName: 'Автоматизация',
    ifDevices: [
      {
        id: 'if_003',
        deviceId: 'device_007',
        deviceName: 'Климат в гостиной',
        deviceType: DeviceType.ClimateSensor,
        room: 'Гостиная',
        params: {
          comparison: 'MORE' as any,
          parameterName: 'temperature',
          parameterNameRus: 'Температура',
          rusValueOnlyView: null,
          description: null,
          paramType: ParameterType.Numeric,
          typeAction: 'device_condition' as any,
          time: null,
          stringValue: null,
          boolValue: null,
          numericValue: 25,
          daysOfWeek: null
        }
      }
    ],
    thenDevices: [
      {
        id: 'then_003',
        deviceId: 'device_017',
        deviceName: 'Кондиционер в зале',
        deviceType: DeviceType.IrDevice,
        room: 'Зал',
        params: {
          comparison: null,
          parameterName: 'power',
          parameterNameRus: 'Питание',
          rusValueOnlyView: null,
          description: null,
          paramType: ParameterType.Bool,
          typeAction: 'zigbee_action' as any,
          time: null,
          stringValue: 'true',
          boolValue: true,
          numericValue: null,
          daysOfWeek: null
        }
      }
    ]
  }
];

const mockSafetySettings: Record<AlarmType, SafetySettings> = {
  [AlarmType.Security]: {
    status: 0,
    info: 'Система охраны активна',
    isEnabled: true,
    resetData: {
      weekDay: Weekday.Fri,
      time: '18:00',
      weekDayTitle: 'Пятница'
    },
    deviceList: [
      mockDevices.find(d => d.id === 'device_008')!,
      mockDevices.find(d => d.id === 'device_009')!
    ].filter(Boolean)
  },
  [AlarmType.Waterleak]: {
    status: 0,
    info: 'Контроль протечек',
    isEnabled: false,
    resetData: null,
    deviceList: [
      mockDevices.find(d => d.id === 'device_010')!
    ].filter(Boolean)
  },
  [AlarmType.Fire]: {
    status: 0,
    info: 'Пожарная безопасность',
    isEnabled: true,
    resetData: null,
    deviceList: [
      mockDevices.find(d => d.id === 'device_011')!
    ].filter(Boolean)
  },
  [AlarmType.None]: {
    status: 0,
    info: null,
    isEnabled: false,
    resetData: null,
    deviceList: []
  }
};

const mockSettings: SettingsSmartHome = {
  showSettings: true
};

const mockRemoteControl: AllowRemoteControl[] = [
  {
    isEnabled: true,
    description: 'Иванов Иван',
    expiresAt: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
    flatId: 1,
    flatAddress: 'ул. Ленина, 1, кв. 10'
  },
  {
    isEnabled: true,
    description: 'Петрова Мария',
    expiresAt: Math.floor(Date.now() / 1000) + 14 * 24 * 60 * 60,
    flatId: 1,
    flatAddress: 'ул. Ленина, 1, кв. 10'
  }
];

class MockSmartHomeAPI {
  private pairingMode = false;
  private pairingDevices: PairingDevice[] = [];
  private pairingTimer: ReturnType<typeof setTimeout> | null = null;

  private async delay(ms: number = 300): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async getDeviceList(flatId: number): Promise<DeviceGroup[]> {
    await this.delay();
    
    const devices = mockDevices.filter(d => d.flatId === flatId);
    
    const grouped: Record<string, Device[]> = {};
    devices.forEach(device => {
      const room = device.room || 'Без комнаты';
      if (!grouped[room]) grouped[room] = [];
      grouped[room].push(device);
    });

    const result = Object.entries(grouped).map(([room, devs]) => ({
      key: room,
      value: devs
    }));

    result.unshift({ key: 'Все', value: devices });

    return result;
  }

  async getDeviceListWithoutGroup(flatId: number): Promise<Device[]> {
    await this.delay();
    return mockDevices.filter(d => d.flatId === flatId);
  }

  async getDevice(flatId: number, deviceId: string): Promise<Device> {
    await this.delay();
    const device = mockDevices.find(d => d.deviceId === deviceId && d.flatId === flatId);
    if (!device) throw new Error('Device not found');
    return device;
  }

  async setDeviceValue(
    _flatId: number,
    deviceId: string,
    parameter: Parameter,
    showLoader = true
  ): Promise<StatusResultCode> {
    await this.delay(showLoader ? 500 : 300);
    
    const device = mockDevices.find(d => d.deviceId === deviceId);
    if (!device) throw new Error('Device not found');

    const paramIndex = device.parameters.findIndex(p => p.name === parameter.name);
    if (paramIndex !== -1) {
      device.parameters[paramIndex] = { 
        ...device.parameters[paramIndex], 
        ...parameter 
      };
      
      const param = device.parameters[paramIndex];
      if (param.type === ParameterType.Bool && param.boolValue !== null) {
        param.rusValueOnlyView = param.boolValue ? 'Включено' : 'Выключено';
        param.readableValue = param.rusValueOnlyView;
      } else if (param.type === ParameterType.Numeric && param.numericValue !== null) {
        if (param.name.includes('temperature')) {
          param.rusValueOnlyView = `${param.numericValue}°C`;
        } else if (param.name.includes('brightness') || param.name.includes('position')) {
          param.rusValueOnlyView = `${param.numericValue}%`;
        } else if (param.name.includes('humidity') || param.name.includes('battery')) {
          param.rusValueOnlyView = `${param.numericValue}%`;
        } else {
          param.rusValueOnlyView = `${param.numericValue}`;
        }
        param.readableValue = param.rusValueOnlyView;
      }
    }

    return { status: 0 as any, isSuccess: true };
  }

  async editDevice(
    _flatId: number,
    deviceId: string,
    newName?: string,
    newRoom?: string
  ): Promise<StatusResultCode> {
    await this.delay();
    
    const device = mockDevices.find(d => d.deviceId === deviceId);
    if (!device) throw new Error('Device not found');

    if (newName !== undefined) device.customName = newName || null;
    if (newRoom !== undefined) device.room = newRoom;

    return { status: 0 as any, isSuccess: true };
  }

  async deleteDevice(_flatId: number, deviceId: string): Promise<StatusData> {
    await this.delay();
    
    const index = mockDevices.findIndex(d => d.deviceId === deviceId);
    if (index !== -1) {
      mockDevices.splice(index, 1);
    }

    return { status: 0, message: 'Device deleted', isSuccess: true };
  }

  async getRoomList(_flatId?: number): Promise<Room[]> {
    await this.delay();
    return mockRooms;
  }

  async getScriptsList(flatId: number, showLoader = false): Promise<ScriptsData> {
    await this.delay(showLoader ? 500 : 300);
    
    const scripts = mockScripts.filter(s => s.flatId === flatId).map(s => ({
      ...s,
      conditionType: s.conditionType || ConditionType.None
    }));
    
    return {
      status: 0,
      scriptList: scripts
    };
  }

  async getScriptsForDevice(
    flatId: number,
    deviceId: string,
    showLoader = false
  ): Promise<ScriptsData> {
    await this.delay(showLoader ? 500 : 300);
    
    const scripts = mockScripts.filter(s => 
      s.flatId === flatId && 
      (s.thenDevices.some(d => d.deviceId === deviceId) ||
       s.ifDevices?.some(d => d.deviceId === deviceId))
    );

    return { status: 0, scriptList: scripts };
  }

  async getAction(_flatId: number, id: string): Promise<ScriptsDataSingle> {
    await this.delay();
    const script = mockScripts.find(s => s.actionId === id);
    return { status: 0, script: script || null };
  }

  async addAction(action: DeviceAction): Promise<StatusResultCode> {
    await this.delay(800);
    
    action.actionId = `script_${Date.now()}`;
    action.id = action.actionId;
    mockScripts.push(action);
    
    return { status: 0 as any, isSuccess: true };
  }

  async editAction(action: DeviceAction): Promise<StatusResultCode> {
    await this.delay(800);
    
    const index = mockScripts.findIndex(s => s.actionId === action.actionId);
    if (index !== -1) {
      mockScripts[index] = action;
    }
    
    return { status: 0 as any, isSuccess: true };
  }

  async deleteAction(action: DeviceAction): Promise<StatusResultCode> {
    await this.delay();
    
    const index = mockScripts.findIndex(s => s.actionId === action.actionId);
    if (index !== -1) {
      mockScripts.splice(index, 1);
    }
    
    return { status: 0 as any, isSuccess: true };
  }

  async startScript(_flatId: number, _eventId: string): Promise<StatusResultCode> {
    await this.delay(800);
    return { status: 0 as any, isSuccess: true };
  }

  async getSafetySettings(
    _flatId: number | undefined,
    group: AlarmType,
    showLoader: boolean
  ): Promise<SafetySettings> {
    await this.delay(showLoader ? 500 : 300);
    return mockSafetySettings[group];
  }

  async getSafetyListType(
    flatId: number | null,
    showLoader: boolean
  ): Promise<SafetyList> {
    await this.delay(showLoader ? 500 : 300);
    
    return {
      showSettings: mockSettings.showSettings,
      securitySettings: mockSafetySettings[AlarmType.Security],
      flatId
    };
  }

  async setIsEnabledForSecurity(
    _flatId: number | undefined,
    isEnabled: boolean | undefined,
    showLoader: boolean
  ): Promise<StatusData> {
    await this.delay(showLoader ? 600 : 300);
    
    mockSafetySettings[AlarmType.Security].isEnabled = isEnabled ?? false;
    
    return { 
      status: 0, 
      message: 'Settings updated',
      isSuccess: true 
    };
  }

  async changeResetData(
    _flatId: number | undefined,
    resetData: { weekDay: Weekday | null; time: string }
  ): Promise<StatusData> {
    await this.delay();
    
    mockSafetySettings[AlarmType.Security].resetData = resetData;
    
    return { 
      status: 0, 
      message: 'Reset schedule updated',
      isSuccess: true 
    };
  }

  async addOrDeleteSecurityDevice(
    _flatId: number | undefined,
    deviceId: string,
    isAdd: boolean
  ): Promise<StatusData> {
    await this.delay();
    
    const settings = mockSafetySettings[AlarmType.Security];
    const device = mockDevices.find(d => d.deviceId === deviceId);
    
    if (isAdd) {
      if (device && !settings.deviceList?.find(d => d.deviceId === deviceId)) {
        settings.deviceList = settings.deviceList || [];
        settings.deviceList.push(device);
      }
    } else {
      if (settings.deviceList) {
        settings.deviceList = settings.deviceList.filter(d => d.deviceId !== deviceId);
      }
    }
    
    return { 
      status: 0, 
      message: 'Device list updated',
      isSuccess: true 
    };
  }

  async getAllowedSecurityDevices(_flatId: number): Promise<Device[]> {
    await this.delay();
    
    const sensorTypes = [
      DeviceType.MotionSensor,
      DeviceType.DoorSensor,
      DeviceType.WaterLeakSensor,
      DeviceType.SmokeSensor,
      DeviceType.GasSensor
    ];
    
    return mockDevices.filter(d => sensorTypes.includes(d.type));
  }

  async getSettings(_flatId?: number, showLoader = true): Promise<SettingsSmartHome> {
    await this.delay(showLoader ? 300 : 100);
    return mockSettings;
  }

  async getAllowRemoteControl(): Promise<AllowRemoteControl[]> {
    await this.delay();
    return mockRemoteControl;
  }

  async setAllowRemoteControl(
    flatId: number | undefined,
    requesterId: number | undefined,
    isEnabled: boolean | undefined
  ): Promise<AllowRemoteControl> {
    await this.delay();
    
    if (requesterId) {
      const existing = mockRemoteControl.find(r => 
        r.description?.includes(String(requesterId))
      );
      
      if (existing) {
        existing.isEnabled = isEnabled ?? false;
        return existing;
      } else if (isEnabled) {
        const newControl: AllowRemoteControl = {
          isEnabled: true,
          description: `Пользователь ${requesterId}`,
          expiresAt: Math.floor(Date.now() / 1000) + 30 * 24 * 60 * 60,
          flatId: flatId || 1,
          flatAddress: 'ул. Ленина, 1, кв. 10'
        };
        mockRemoteControl.push(newControl);
        return newControl;
      }
    }
    
    return mockRemoteControl[0];
  }

  async setPairingMode(
    _flatId: number | undefined,
    value: boolean | undefined,
    showLoader = true
  ): Promise<StatusData> {
    await this.delay(showLoader ? 500 : 200);
    
    this.pairingMode = value ?? false;
    
    if (this.pairingMode) {
      this.pairingTimer = setTimeout(() => {
        this.pairingDevices = [
          { deviceId: 'new_001', name: 'Умная лампа', type: 'relay', id: 'new_001' },
          { deviceId: 'new_002', name: 'Датчик движения', type: 'motion_sensor', id: 'new_002' }
        ];
      }, 2000);
    } else {
      if (this.pairingTimer) {
        clearTimeout(this.pairingTimer);
      }
      this.pairingDevices = [];
    }
    
    return { 
      status: 0, 
      message: this.pairingMode ? 'Pairing mode enabled' : 'Pairing mode disabled',
      isSuccess: true 
    };
  }

  async getPairingDeviceList(
    _flatId: string | undefined,
    showLoader = true
  ): Promise<PairingDeviceList> {
    await this.delay(showLoader ? 300 : 100);
    return { devices: this.pairingDevices };
  }

  async setDevicePairing(
    flatId: number | undefined,
    deviceId: string | undefined,
    name: string | undefined,
    room: string | undefined
  ): Promise<StatusData> {
    await this.delay(1000);
    
    const pairingDevice = this.pairingDevices.find(d => d.deviceId === deviceId);
    if (pairingDevice) {
      mockDevices.push({
        id: deviceId!,
        baseName: pairingDevice.name || 'Новое устройство',
        customName: name || null,
        deviceId: deviceId!,
        type: pairingDevice.type as DeviceType,
        room: room || 'Гостиная',
        isOnline: true,
        parameters: [
          { 
            id: 'power', 
            name: 'power', 
            rusName: 'Питание', 
            type: ParameterType.Bool, 
            boolValue: false,
            stringValue: null,
            numericValue: null,
            rusValueOnlyView: 'Выключено',
            readableValue: 'Выключено'
          }
        ],
        rusType: null,
        flatId: flatId || 1,
        index: mockDevices.length,
        deviceState: null
      });
      
      this.pairingDevices = this.pairingDevices.filter(d => d.deviceId !== deviceId);
    }
    
    return { 
      status: 0, 
      message: 'Device paired successfully',
      isSuccess: true 
    };
  }

  async getDeviceStatistic(
    _flatId: number,
    deviceId: string,
    parameterName: string,
    startTime: Date,
    endTime: Date,
    showLoader = true
  ): Promise<DeviceStatistic> {
    await this.delay(showLoader ? 800 : 300);
    
    const statsKey = parameterName as keyof typeof mockDeviceStatistics;
    const statsData = mockDeviceStatistics[statsKey] || mockDeviceStatistics.temperature;
    
    return {
      deviceId,
      parameterName,
      startTime: startTime.toISOString(),
      endTime: endTime.toISOString(),
      periodType: 0,
      data: statsData.map(d => ({
        timestamp: d.timestamp,
        value: d.value,
        stringValue: String(d.value)
      }))
    };
  }

  getDevices(): Device[] {
    return mockDevices;
  }

  getScripts(): DeviceAction[] {
    return mockScripts;
  }

  updateDevice(deviceId: string, updates: Partial<Device>): void {
    const device = mockDevices.find(d => d.deviceId === deviceId);
    if (device) {
      Object.assign(device, updates);
    }
  }
}

export const mockAPI = new MockSmartHomeAPI();
export default mockAPI;
export { mockScripts };
